var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSetting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.25c-.422 0-.75.375-.75.75v1.078l8.063 6.61a2.615 2.615 0 0 0 3.328 0l8.109-6.61V10c0-.375-.375-.75-.75-.75H7zm-.75 4.734V22c0 .422.328.75.75.75h18c.375 0 .75-.328.75-.75v-8.016l-6.656 5.438c-1.828 1.5-4.407 1.5-6.188 0L6.25 13.984zM4 10c0-1.64 1.313-3 3-3h18c1.64 0 3 1.36 3 3v12c0 1.688-1.36 3-3 3H7c-1.688 0-3-1.313-3-3V10z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSetting);
export default __webpack_public_path__ + "static/media/email-setting.dfa883163639a033652d6c26c543c14c.svg";
export { ForwardRef as ReactComponent };